import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Register from '../views/Register.vue'
import Home from '../views/Home.vue'
import Access from '../views/Access.vue'
import My from '../views/My.vue'
import Questionnaire from '../views/Questionnaire.vue'
import Announcement from '../views/Announcement.vue'
import getPageTitle from '@/utils/title'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'announcement',
    component: Announcement,
    meta: {
      title: "德阳智慧招投标综合服务监管系统"
    }
  },
  {
    path: '/questionnaire',
    name: 'questionnaire',
    component: Questionnaire,
    meta: {
      title: "德阳智慧招投标综合服务监管系统"
    }
  },
  {
    path: '/',
    name: 'login',
    component: Login,
    meta: {
      title: "登录"
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      title: "注册"
    }
  },
  {
    path: '/my',
    name: 'my',
    component: My,
    meta: {
      title: "我的"
    }
  },
  {
    path: '/access',
    name: 'access',
    component: Access,
    meta: {
      title: "德阳工程履约保证金"
    }
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    meta: {
      title: "德阳工程履约保证金"
    }
  },
]

const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes
})

router.beforeEach(async (to, from, next) => {
  document.title = getPageTitle(to.meta.title)
  next()
})
export default router
